import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25.11 18h-1.79a1.46 1.46 0 00-1.06.44L20.7 20h-9.17L10 18.44A1.47 1.47 0 008.91 18h-1.8a1 1 0 100 2H8.7l1.56 1.56a1.5 1.5 0 001.06.44h9.59a1.52 1.52 0 001.09-.44L23.53 20h1.58a1 1 0 000-2zm-16.2 2z"/><path d="M18.92 12.62a1.15 1.15 0 00-.21-.33l-4-4a1 1 0 00-1.42 1.42l2.3 2.29H3a1 1 0 000 2h12.59l-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l4-4a1.15 1.15 0 00.21-.33A1 1 0 0019 13a.92.92 0 00-.08-.38z"/><path d="M30 18.41V26a2 2 0 01-2 2H4a2 2 0 01-2-2v-7.59a2.14 2.14 0 01.16-.79l.08-.19.36-.83a1 1 0 01.92-.6 1 1 0 01.93 1.35l-.18.41-.18.42-.09.23V26h24v-7.59L22.68 6H9.32l-.26.6-.88 2.06-.32.73A1 1 0 017 10a1 1 0 01-1-1.4l1.22-2.78.26-.61A2 2 0 019.32 4h13.36a2 2 0 011.84 1.21l5.32 12.41a2 2 0 01.16.79z"/>';
export var RestoreOutlineSVG = function RestoreOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
RestoreOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(RestoreOutlineSVG);